'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Copy_module = require('./Copy.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const CopyIcon = ({
  s = {},
  ariaTitle
}) => {
  const {
    iconsPrimaryNone: copyIconStyle
  } = nthHookTheme.useTheme();
  const style = {
    ...copyIconStyle,
    ...s
  };
  const color = style.color ?? '#000';
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    role: "img",
    className: Copy_module["default"].container,
    style: {
      fill: color,
      ...style
    },
    viewBox: "0 0 18 18"
  }, ariaTitle && /*#__PURE__*/React__default["default"].createElement("title", null, ariaTitle), /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_68_13094)"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6.125",
    y: "5",
    width: "11.375",
    height: "12.5",
    rx: "1",
    stroke: color
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5L13.5 1.5C13.5 0.671574 12.8284 1.13338e-06 12 1.06096e-06L2.625 2.4137e-07C1.79657 1.68947e-07 1.125 0.671573 1.125 1.5L1.125 12C1.125 12.8284 1.79657 13.5 2.625 13.5L5.625 13.5L5.625 7C5.625 5.61929 6.74429 4.5 8.125 4.5L13.5 4.5Z",
    fill: color
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_68_13094"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  })))));
};
var Copy = nthHookTheme.withThemeProvider(CopyIcon, {
  themeTokens: ['iconsPrimaryNone']
});

exports["default"] = Copy;
